module.exports = __webpack_public_path__ + "static/media/telegram_logo.4b58af26.svg";